module.exports = __webpack_public_path__ + "media/images/flags/1x1/ncl-1cf5b27907b68f96c367699d905a4d6c.svg";